import React from 'react'

import Header from './components/Header/Header'
import Footer from './components/Footer/Footer'

const App = () => {
    return (
        <div>
            <Header></Header>
            <Footer></Footer>
        </div>
    )
}

export default App